import React from 'react';

import * as S from './PopularDestinationsUI.styles';

import fallbackImage from '../../../../assets/fallback-image.png';
import {SectionHeader} from '../../../CommonStyleUtils/dwebCommon.styles';

const PopularDestinationsUI = ({destinationsFromState, gaHandler}) => {
  const {popular_destinations, meta_config} = destinationsFromState;
  const {text, id_list} = popular_destinations;
  const {entities_data} = meta_config;

  const cityList = id_list.map(item => entities_data[item]).filter(item => item.go_data);
  cityList.length = cityList.length - (cityList.length % 5);
  const cityListTempMassaged = [];

  cityList.map((item, index) => {
    if (index % 5 === 0) {
      cityListTempMassaged.push(item);
      return;
    }

    if (
      !Array.isArray(cityListTempMassaged[cityListTempMassaged.length - 1]) ||
      cityListTempMassaged[cityListTempMassaged.length - 1].length === 2
    ) {
      cityListTempMassaged.push([item]);
      return;
    }
    cityListTempMassaged[cityListTempMassaged.length - 1].push(item);
    return;
  });

  let cityListMassaged = [];
  cityListTempMassaged.map((item, index) => {
    if (!cityListMassaged.length || cityListMassaged[cityListMassaged.length - 1].length > 2) {
      cityListMassaged = [...cityListMassaged, [item]];
      return;
    }
    cityListMassaged[cityListMassaged.length - 1].push(item);
  });

  const renderSmallImageListItem = columnItem => {
    return (
      <S.PopularSmallImageOuterWrapper>
        {columnItem.map((subItem, subItemIndex) => (
          <S.PopularSmallImageWrapper
            key={subItemIndex}
            href={subItem.seo_url || ''}
            title={subItem.h_text || ''}
            onClick={() => {
              gaHandler(subItem);
            }}
          >
            <S.PopularSmallImage
              src={
                (subItem &&
                  subItem.img_processed &&
                  subItem.img_processed.landscape &&
                  subItem.img_processed.landscape.jpg &&
                  subItem.img_processed.landscape.jpg.g) ||
                ''
              }
              alt={subItem.h_text || ''}
              fallback={fallbackImage}
            />
            <S.PopularImageOverlayWrap>
              <S.OverlayMainText>{subItem.h_text || ''}</S.OverlayMainText>
              <S.OverlaySubText>{subItem.sub_text || ''}</S.OverlaySubText>
            </S.PopularImageOverlayWrap>
          </S.PopularSmallImageWrapper>
        ))}
      </S.PopularSmallImageOuterWrapper>
    );
  };

  const renderBigImageListItem = columnItem => {
    return (
      <S.PopularBigImageWrapper
        href={columnItem.seo_url || ''}
        title={columnItem.h_text || ''}
        onClick={() => {
          gaHandler(columnItem);
        }}
      >
        <S.PopularBigImage
          src={
            (columnItem &&
              columnItem.img_processed &&
              columnItem.img_processed.portrait &&
              columnItem.img_processed.portrait.jpg &&
              columnItem.img_processed.portrait.jpg.g) ||
            ''
          }
        />
        <S.PopularImageOverlayWrap>
          <S.OverlayMainText>{columnItem.h_text || ''}</S.OverlayMainText>
          <S.OverlaySubText>{columnItem.sub_text || ''}</S.OverlaySubText>
        </S.PopularImageOverlayWrap>
      </S.PopularBigImageWrapper>
    );
  };

  const renderItemsInZigZagOrder = (rowItem, rowItemIndex) => {
    let arr = [];
    if (rowItemIndex % 2 === 0) {
      rowItem[0] && arr.push(renderBigImageListItem(rowItem[0]));
      rowItem[1] && arr.push(renderSmallImageListItem(rowItem[1]));
      rowItem[2] && arr.push(renderSmallImageListItem(rowItem[2]));
    } else {
      rowItem[1] && arr.push(renderSmallImageListItem(rowItem[1]));
      rowItem[2] && arr.push(renderSmallImageListItem(rowItem[2]));
      rowItem[0] && arr.push(renderBigImageListItem(rowItem[0]));
    }
    return arr;
  };

  return (
    <S.PopularDestMainWrapper>
      <SectionHeader>Popular Destinations</SectionHeader>
      <S.PopularDestHeaderSubText>{text}</S.PopularDestHeaderSubText>
      {cityListMassaged.map((rowItem, rowItemIndex) => (
        <S.PopularImageOuterWrapper key={rowItemIndex}>
          {renderItemsInZigZagOrder(rowItem, rowItemIndex)}
        </S.PopularImageOuterWrapper>
      ))}
    </S.PopularDestMainWrapper>
  );
};

export default React.memo(PopularDestinationsUI);
